import { Controller } from '@hotwired/stimulus';

// Connects to data-controller='checkout'
export default class extends Controller {
  static values = {
    publishableKey: String,
    checkoutSessionUrl: String,
    // The subscription ID to pass to the Stripe checkout session
    // It might be nil for a new subscription
    subscriptionId: String,
  };

  async connect() {
    await this.loadStripe();
    this.initializeStripe();
  }

  async disconnect() {
    window.Stripe = undefined;
    this.element.innerHTML = '';
  }

  async loadStripe() {
    if (!window.Stripe) {
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      document.head.appendChild(script);
      await new Promise((resolve) => {
        script.onload = resolve;
      });
    }
  }

  async initializeStripe() {
    const stripe = window.Stripe(this.publishableKeyValue);

    const fetchClientSecret = async () => {
      // pass csrf token
      const response = await fetch(this.checkoutSessionUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({
          subscription_id: this.subscriptionIdValue,
        }),
      });
      const { clientSecret } = await response.json();
      return clientSecret;
    };

    const checkout = await stripe.initEmbeddedCheckout({ fetchClientSecret });
    checkout.mount(this.element);
  }
}
